import './src/styles/tokens.css';
import './src/styles/primitives.css';
import './src/styles/globals.css';
import './src/styles/site.css';

export const onClientEntry = () => {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
};

export const onRouteUpdate = () => {
  window.requestAnimationFrame(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  });
};

export const shouldUpdateScroll = () => {
  return false;
};
